import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { setDates } from "../reducers/global";
import "./DateFilter.css";

class DateFilter extends React.Component {
  state = {
    dateFrom: this.props.dateFrom,
    dateTo: this.props.dateTo,
    index: this.props.index,
  };

  getCurrentFinYear = (start, yearEnd) => {
    if (
      moment(start).startOf("month") <
      moment(start).month(yearEnd).startOf("month")
    ) {
      return moment(start.startOf("month"))
        .subtract(1, "year")
        .add(2, "month")
        .month(yearEnd)
        .add(1, "month");
    } else {
      return moment(start).month(yearEnd).add(1, "month");
    }
  };

  setCurrentPeriod = () => {
    const { index } = this.props;
    let dateFrom, dateTo;

    switch (index) {
      case 0: // month
        dateFrom = moment().startOf("month");
        dateTo = moment(dateFrom).add(1, "month").endOf("month");
        break;
      case 1: // year
        dateFrom = this.getCurrentFinYear(moment(), 1);
        dateTo = moment(dateFrom)
          .add(1, "year")
          .subtract(1, "month")
          .endOf("month");
        break;
      case 2: // day
        dateFrom = moment().startOf("day");
        dateTo = moment().endOf("day");
        break;
      default:
        return;
    }

    this.props.dispatchSetDates(dateFrom, dateTo, index);
    this.props.action(dateFrom, dateTo);
  };

  handleNavigation = (direction) => {
    const { index, dateFrom, dateTo } = this.props;
    let newDateFrom, newDateTo;

    switch (index) {
      case 0: // month
        newDateFrom = moment(dateFrom)[direction](1, "month").startOf("month");
        newDateTo = moment(newDateFrom).endOf("month");
        break;
      case 1: // year
        newDateFrom = moment(dateFrom)[direction](1, "year").startOf("month");
        newDateTo = moment(dateTo)[direction](1, "year").endOf("month");
        break;
      case 2: // day
        newDateFrom = moment(dateFrom)[direction](1, "day").startOf("day");
        newDateTo = moment(newDateFrom).endOf("day");
        break;
      default:
        return;
    }

    this.props.dispatchSetDates(newDateFrom, newDateTo, index);
    this.props.action(newDateFrom, newDateTo);
  };

  handleViewChange = (newIndex) => {
    if (newIndex === this.props.index) return;

    let dateFrom, dateTo;

    switch (newIndex) {
      case 0: // month
        dateFrom = moment().startOf("month");
        dateTo = moment(dateFrom).add(1, "month").endOf("month");
        break;
      case 1: // year
        dateFrom = this.getCurrentFinYear(this.props.dateFrom, 1);
        dateTo = moment(dateFrom)
          .add(1, "year")
          .subtract(1, "month")
          .endOf("month");
        break;
      case 2: // day
        dateFrom = moment(this.props.dateFrom).startOf("day");
        dateTo = moment(this.props.dateFrom).endOf("day");
        break;
      default:
        return;
    }

    this.props.dispatchSetDates(dateFrom, dateTo, newIndex);
    this.props.action(dateFrom, dateTo);
  };

  formatDateDisplay = () => {
    const { index, dateFrom, dateTo } = this.props;

    switch (index) {
      case 0: // month
        return dateFrom.format("MMMM YYYY");
      case 1: // year
        return `${dateFrom.format("MMM DD, YYYY")} – ${dateTo.format(
          "MMM DD, YYYY"
        )}`;
      case 2: // day
        return dateFrom.format("MMM DD, YYYY");
      default:
        return "";
    }
  };

  render() {
    const { index } = this.props;

    return (
      <div className="date-filter">
        <div className="date-filter-toolbar">
          <div className="date-nav-buttons">
            <button
              type="button"
              onClick={() => this.handleNavigation("subtract")}
              className="date-nav-btn"
              title="Previous period"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button
              type="button"
              onClick={() => this.handleNavigation("add")}
              className="date-nav-btn"
              title="Next period"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
            <button
              type="button"
              onClick={this.setCurrentPeriod}
              className="current-period-btn"
              title="Current period"
            >
              Current
            </button>
          </div>

          <div className="date-display">{this.formatDateDisplay()}</div>

          <div className="view-toggle-buttons">
            <button
              onClick={() => this.handleViewChange(1)}
              type="button"
              className={`view-toggle-btn ${index === 1 ? "active" : ""}`}
              title="Year view"
            >
              Year
            </button>
            <button
              onClick={() => this.handleViewChange(0)}
              type="button"
              className={`view-toggle-btn ${index === 0 ? "active" : ""}`}
              title="Month view"
            >
              Month
            </button>
            <button
              onClick={() => this.handleViewChange(2)}
              type="button"
              className={`view-toggle-btn ${index === 2 ? "active" : ""}`}
              title="Day view"
            >
              Day
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dateFrom: state.global.dateFrom,
  dateTo: state.global.dateTo,
  index: state.global.dateIndex,
  company: state.companies.company,
});

const mapDispatchToProps = {
  dispatchSetDates: (dateFrom, dateTo, index) =>
    setDates(dateFrom, dateTo, index),
};

export default connect(mapStateToProps, mapDispatchToProps)(DateFilter);
